import Serializable from './serializable';

export class Subscriber extends Serializable {

	id: string;

	email: string;
	firstName: string;
	lastName: string;

	name: string;

	creationDate: number;

	games: [];
}
